import { Layout } from 'components'
import { CurrentUserContextProvider } from 'context'
import { ResourceCenterContent } from './ResourceCenterContent'

/** Resource Center index (AR-623). Knowledge base for teachers and managers. */
export const ResourceCenterPage = () => {
  return (
    <CurrentUserContextProvider>
      <Layout>
        <ResourceCenterContent />
      </Layout>
    </CurrentUserContextProvider>
  )
}
